import { Column, Index, PrimaryColumn } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsBoolean,
  IsDate,
  IsNumber,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicEntityWithoutId } from '../basic/basic.entity';

export class IpMeta extends BasicEntityWithoutId {
  @ApiProperty()
  @IsString({ groups: ['error'] })
  @PrimaryColumn({ type: 'varchar' })
  normalizedIp: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: true })
  asn?: number | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', length: 2, nullable: true })
  country?: string | null;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  @Column({ type: 'boolean', nullable: false, default: false })
  isVpn: boolean;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  @Column({ type: 'boolean', nullable: false, default: false })
  isHosting: boolean;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: true })
  subnetV4_24?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: true })
  subnetV6_64?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  lastResolvedAt?: Date | null;
}
